import { Navigate, Outlet } from "react-router-dom";
import Cookie from 'cookie-universal';
export default function RequierBack ()
{
    const cookie = Cookie();
    const token = cookie.get( "ecommerce" );
    return token ? window.history.back() : <Outlet />;

}